import { Container, Stack } from "@mui/material";
import useClientContext from "../../contexts/useClientContext";
import useClientPageTitle from "../../contexts/useClientPageTitle";
import PortfolioWidgetPreviewCard from "../widgets/mobile/PortfolioWidgetPreviewCard";

const PortfolioMobilePage = () => {
  useClientPageTitle("Portfolio");

  const { portfolioWidget } = useClientContext();

  return (
    <Container sx={{ flex: 1 }}>
      <Stack spacing={2} sx={{ py: 2 }}>
        {portfolioWidget && <PortfolioWidgetPreviewCard widgetSettings={portfolioWidget} />}
      </Stack>
    </Container>
  );
};

export default PortfolioMobilePage;
